/* eslint-disable import/export */
import SnackbarServiceProvider from "./SnackbarService";
export * from './SnackbarService';
export default SnackbarServiceProvider;